import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SFilterSelect = styled.div`
  width: 240px;

  ${setFlexDFFDC};
`;
